import {
  userPlanOptions,
  userPlanVariantOptions,
  userSubscriptionStatusOptions,
} from "@luntero/db/contracts/plans";
export {
  userPlanOptions,
  userPlanVariantOptions,
  userSubscriptionStatusOptions,
} from "@luntero/db/contracts/plans";
import type Stripe from "stripe";

export type UserPlanOption = (typeof userPlanOptions)[number];

export const userPlanVariantData: Record<
  UserPlanVariant,
  { priceCents: number }
> = {
  PRO_3_DAYS: {
    priceCents: 300,
  },
  PRO_1_WEEK: {
    priceCents: 500,
  },
  PRO_1_MONTH: {
    priceCents: 1500,
  },
};

export type UserPlanVariant = (typeof userPlanVariantOptions)[number];

export const stripePriceIdByVariant: Record<UserPlanVariant, string> = {
  // PRO_3_DAYS: "price_1ScO7y6v8aLgrVFeQA0QyW5X",
  // PRO_1_WEEK: "price_1ScO7y6v8aLgrVFeVld3rmdb",
  // PRO_1_MONTH: "price_1ScO7y6v8aLgrVFeiYkq5GOs",
  PRO_3_DAYS: "price_1Sjh4w8ccYetbGsm9iA6b9UG",
  PRO_1_WEEK: "price_1Sjh4w8ccYetbGsmXgGNVY8C",
  PRO_1_MONTH: "price_1Sjh4w8ccYetbGsmORzK6Vwc",
};

export type UserSubscriptionStatus =
  (typeof userSubscriptionStatusOptions)[number];

export function mapStripeStatusToUserStatus(
  status: Stripe.Subscription.Status | null
): UserSubscriptionStatus {
  switch (status) {
    case "active":
      return "ACTIVE";
    case "trialing":
      return "TRIALING";
    case "past_due":
      return "PAST_DUE";
    case "canceled":
      return "CANCELED";
    case "incomplete":
      return "INCOMPLETE";
    case "incomplete_expired":
      return "INCOMPLETE_EXPIRED";
    case "paused":
      return "PAUSED";
    case "unpaid":
      return "UNPAID";
    default:
      return "NONE";
  }
}

export type UserCheckoutBody = {
  locale: string;
  variant: UserPlanVariant;
  baseUrl: string;
};
